module.exports = __webpack_public_path__ + "media/images/MiniCreditCard-f932fd89.svg";